import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d237c5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container cardsBlock" }
const _hoisted_2 = { class: "mb--20 none-Mobile" }
const _hoisted_3 = {
  key: 1,
  class: "mb--20"
}
const _hoisted_4 = { class: "mb--25" }
const _hoisted_5 = { class: "check-result__card-title" }
const _hoisted_6 = { class: "m-font-size" }
const _hoisted_7 = {
  key: 0,
  class: "m-font-size"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "check-result__card-options" }
const _hoisted_11 = { class: "check-result__card-options-item" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "mb--25" }
const _hoisted_14 = { class: "check-result__card-title" }
const _hoisted_15 = { class: "m-font-size" }
const _hoisted_16 = {
  key: 0,
  class: "m-font-size"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "check-result__card-options twoColumns" }
const _hoisted_20 = { class: "check-result__card-options-column-item" }
const _hoisted_21 = { class: "third-color" }
const _hoisted_22 = { class: "check-result__card-options-column-result" }
const _hoisted_23 = { class: "mb--20 only-mobile" }

import { computed, onMounted, Ref, ref } from 'vue';
import { LocationQueryValue, useRoute, useRouter } from 'vue-router';
import { useCheckResultStore } from '@/store/modules/checkResult';
import { InfoTopBar, SecondHeader } from '@/components';
import { CheckResultItemType, CheckResultRequestType } from '@/api/check/types';
import { prepareUrl } from '@/utils/Common/Common';
import { prepareValueByType } from '@/utils/Common/DeveloperAdmin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckResultComponent',
  setup(__props) {

const showItems = ref(true);

const checkResult: Ref<CheckResultRequestType | undefined> = ref(undefined);
const loading = ref(false);
const router = useRouter();

const prepareValue = (param: CheckResultItemType) => {
  if (!param.value) {
    return '-';
  }
  if (param.type === 12 || param.type === 20) {
    return param.value;
  }

  return prepareValueByType(param).value;
};

const route = useRoute();
const checkId = computed((): LocationQueryValue | LocationQueryValue[] | undefined => {
  if (route?.query) {
    return route?.query?.id;
  } else {
    return undefined;
  }
});

onMounted(async () => {
  loading.value = true;

  if (checkId.value) {
    try {
      const res = await useCheckResultStore().searchCheckResultById(+checkId.value);

      if (res) {
        checkResult.value = { ...res, logo: prepareUrl(res.logo) as string };
      } else {
        await router.push({ name: 'main' });
      }
    } finally {
      loading.value = false;
    }
  } else {
    await router.push({ name: 'main' });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_expansion_panels = _resolveComponent("base-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InfoTopBar), { text: "В данном разделе вы можете ознакомиться с юридическими рисками. Сервис предоставляет информацию на основе сбора, систематизации и анализа сведений." })
    ]),
    (checkResult.value)
      ? (_openBlock(), _createBlock(_unref(SecondHeader), {
          key: 0,
          modelValue: showItems.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showItems).value = $event)),
          logo: checkResult.value?.logo,
          "offer-card-url": !checkResult.value?.isDeveloper ? checkResult.value.customUrl : undefined,
          phone: checkResult.value?.phone,
          title: checkResult.value?.isDeveloper ? checkResult.value?.brandName : checkResult.value?.address,
          address: "offerCard.address"
        }, {
          btn: _withCtx(() => [
            _createVNode(_component_base_button, {
              href: {
            name: checkResult.value?.isDeveloper ? 'developer' : 'offerCard',
            params: { url: checkResult.value.customUrl },
          },
              text: checkResult.value?.isDeveloper ? 'К застройщику' : 'К объявлению',
              "all-block-width": "",
              class: "no-wrap",
              "style-type": "coloredBorder"
            }, null, 8, ["href", "text"])
          ]),
          _: 1
        }, 8, ["modelValue", "logo", "offer-card-url", "phone", "title"]))
      : _createCommentVNode("", true),
    (showItems.value && checkResult.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkResult.value.entities, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (item.icons.length)
                ? (_openBlock(), _createBlock(_component_base_expansion_panels, {
                    key: 0,
                    "is-open": true,
                    styleColor: "green"
                  }, {
                    title: _withCtx((titleProps) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1),
                          (checkResult.value.isDeveloper)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, ": " + _toDisplayString(item.companyTitle), 1))
                            : _createCommentVNode("", true),
                          (item.checkDate)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, ", дата проверки: " + _toDisplayString(item.checkDate), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          class: "gradient-color",
                          onClick: ($event: any) => (titleProps.events.handleClick())
                        }, _toDisplayString(titleProps.data ? 'Свернуть' : 'Развернуть'), 9, _hoisted_9)
                      ])
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.icons, (icon, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createElementVNode("span", _hoisted_11, [
                              _createTextVNode(_toDisplayString(icon.title) + " ", 1),
                              (icon.value === '2')
                                ? (_openBlock(), _createBlock(_component_base_icon, {
                                    key: 0,
                                    color: "#009D3E",
                                    height: "17",
                                    name: "check_circle",
                                    width: "17"
                                  }))
                                : (icon.value === '3')
                                  ? (_openBlock(), _createBlock(_component_base_icon, {
                                      key: 1,
                                      color: "#EA1F1F",
                                      height: "17",
                                      name: "warning",
                                      width: "17"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_12, " - "))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]))
          }), 256)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkResult.value.entities, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (item.info.length)
                ? (_openBlock(), _createBlock(_component_base_expansion_panels, {
                    key: 0,
                    "is-open": true,
                    styleColor: "orange"
                  }, {
                    title: _withCtx((titleProps) => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(item.title), 1),
                          (checkResult.value.isDeveloper)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, ": " + _toDisplayString(item.companyTitle), 1))
                            : _createCommentVNode("", true),
                          (item.checkDate)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, ", дата проверки: " + _toDisplayString(item.checkDate), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          class: "gradient-color",
                          onClick: ($event: any) => (titleProps.events.handleClick())
                        }, _toDisplayString(titleProps.data ? 'Свернуть' : 'Развернуть'), 9, _hoisted_18)
                      ])
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.info, (infoItem, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(infoItem.title), 1),
                              _createElementVNode("div", _hoisted_22, _toDisplayString(prepareValue(infoItem)), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_unref(InfoTopBar), { text: "В данном разделе вы можете ознакомиться с юридическими рисками. Сервис предоставляет информацию на основе сбора, систематизации и анализа сведений." })
    ])
  ]))
}
}

})